import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import DagBoekList from "./detail/DagBoekList";
import { getUser, getUserdetails } from "../../Localstorage/localstorage";
import Swal from "sweetalert2";
import { AXIOS_POST, AXIOS_UPDATE } from "../../server/api/crud";
import ReInput from "../../Componenten/Layout/ReInput";
import TypeNote from "./TypeNote";
import { DocumentIcon, PaperClipIcon } from "@heroicons/react/24/solid";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import Select2 from "../../Componenten/Select2";
import RPDrawerComment from "../../Componenten/Drawers/RPDrawerComment";
import { useSelector } from "react-redux";
import SelectPatienten from "../../Componenten/SelectPatienten";
import moment from "moment";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

const EetdagboekAdmin = ({}) => {
  const { patienten } = useSelector((state) => state.user);
  const [dagboeken, setDagboeken] = useState([]);
  const user = getUser();
  const userdetails = getUserdetails();
  const [command, setCommand] = useState("insert");
  const [refresh, setRefresh] = useState(false);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(patienten[0]);
  const [showEdit, setShowEdit] = useState(true);
  const [mobilePanelOpen, setMobilePanelOpen] = useState(false);

  const [dates, setdates] = useState({
    startdate: moment().startOf('month').format('YYYY-MM-DD'),
    enddate: moment().endOf('month').format('YYYY-MM-DD'),
  });

  const eetdagboek = {
    user_id: user?.id,
    datum: new Date(),
    dag: "",
    ochtend: "",
    voormiddag: "",
    middag: "",
    namiddag: "",
    avond: "",
    smorgens: "",
    smiddags: "",
    savonds: "",
    type_note: 1,
    title: "",
    admin: userdetails?.full_name || user?.username,
    admin_id: userdetails?.user_id || user?.id,
    score: 0,
    opmerking: "",
  };

  let commentaaradmin = {
    admin: userdetails?.full_name || user?.username,
    admin_id: userdetails?.user_id || user?.id,
    score: 0,
    opmerking: "",
  };

  const [updateAdmin, setUpdateAdmin] = useState(commentaaradmin);
  const [formData, setFormData] = useState(eetdagboek);

  useEffect(() => {
    const fetchDaymealData = async (search) => {
      let adminUpdate = {};
      try {
        const response = await AXIOS_POST(`eetdagboek/user`, search);
        let eetdagboeken = response.data.data;

        setDagboeken(eetdagboeken);
        setRefresh(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    let newId = selected?.user_id || patienten[0]?.user_id;
    const search = {
      id: newId,
      startdate: moment(dates?.startdate).format('YYYY-MM-DD'),
      enddate: moment(dates?.enddate).format('YYYY-MM-DD'),
    };
    if (selected || patienten?.length > 0 || formData || dates) {
      fetchDaymealData(search);
    }
  }, [open, patienten, formData, selected, dates?.startdate, dates?.enddate]);

  /* useEffect(() => {
    if (selected)
      setdates({
        ...dates,
        startdate: moment(selected?.created_at).format("YYYY-MM-DD"),
      });
  }, [selected]); */

  const validateForm = () => {
    if (!formData?.score) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title:
          "De gegevens zijn niet opgeslagen. Gelieve een score in te voeren. Deze wordt meegerekend bij de vooruitgang van de klant.",
        showConfirmButton: false,
        timer: 2500,
      });
      return false;
    }

    return true;
  };

  const Opslaan = async () => {
    if (!validateForm()) return;
    const newObject = {
      admin: formData.admin,
      admin_id: formData.admin_id,
      score: formData.score,
      opmerking: formData.opmerking,
    };
    try {
      await AXIOS_UPDATE(`eetdagboek/adminComments`, formData.id, newObject);
      setCommand(null);
      Swal.fire("Gegevens zijn gewijzigd", "", "success");
      setRefresh(true);
    } catch (error) {
      console.error("Error updating data:", error);
      Swal.fire("Er is een fout opgetreden bij het wijzigen", "", "error");
    }

    setOpen(false);
  };

  const EditTekst = async (item, cmd) => {
    setFormData((prev) => ({
      ...prev,
      id: item?.eetdagboek_id || "",
      user_id: item?.eetdagboek_user_id || "",
      datum: item?.eetdagboek_datum || new Date(),
      dag: item?.eetdagboek_dag || "",
      ochtend: item?.eetdagboek_ochtend || "",
      voormiddag: item?.eetdagboek_voormiddag || "",
      middag: item?.eetdagboek_middag || "",
      namiddag: item?.eetdagboek_namiddag || "",
      avond: item?.eetdagboek_avond || "",
      smorgens: item?.eetdagboek_smorgens || "",
      smiddags: item?.eetdagboek_smiddags || "",
      savonds: item?.eetdagboek_savonds || "",
      type_note: item?.eetdagboek_type_note || 1,
      title: item?.eetdagboek_title || "",
      admin: item?.eetdagboek_admin || commentaaradmin.admin,
      admin_id: item?.eetdagboek_admin_id || commentaaradmin.admin_id,
      score: item?.eetdagboek_score || 0,
      opmerking: item?.eetdagboek_opmerking || "",
      url: item?.eetdagboek_url || "",
    }));
  };

  const loadEntryFromList = (item, cmd) => {
    setMobilePanelOpen(false);
    EditTekst(item, cmd);
  };

  const renderSidebarBody = (forDrawer) => {
    const sfx = forDrawer ? "-drawer" : "";
    return (
      <>
        <div className="rounded-2xl border border-wa-border bg-wa-panel2/70 p-4 shadow-[0_16px_48px_-28px_rgba(0,0,0,0.55)]">
          <h3 className="text-sm font-semibold tracking-tight text-wa-text">Patiënt &amp; periode</h3>
          <p className="mt-1 text-xs text-wa-muted">Filter op datum — toon dagboeken binnen dit bereik</p>
          <div className="mt-3">
            {patienten.length > 0 && (
              <SelectPatienten variant="wa" selected={selected} setSelected={setSelected} />
            )}
          </div>
          <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
            <label className="block sm:col-span-1">
              <span className="mb-1 block text-xs font-medium text-wa-muted">Van</span>
              <input
                type="date"
                name="startdate"
                id={`startdate${sfx}`}
                className="block w-full rounded-lg border border-wa-border bg-wa-panel px-2.5 py-2 text-sm text-wa-text shadow-sm outline-none transition-colors focus:border-wa-accent/50 focus:ring-2 focus:ring-wa-accent/20"
                value={moment(dates.startdate).format("YYYY-MM-DD")}
                onChange={(e) => setdates({ ...dates, startdate: e.target.value })}
              />
            </label>
            <label className="block sm:col-span-1">
              <span className="mb-1 block text-xs font-medium text-wa-muted">Tot</span>
              <input
                type="date"
                name="enddate"
                id={`enddate${sfx}`}
                className="block w-full rounded-lg border border-wa-border bg-wa-panel px-2.5 py-2 text-sm text-wa-text shadow-sm outline-none transition-colors focus:border-wa-accent/50 focus:ring-2 focus:ring-wa-accent/20"
                value={moment(dates.enddate).format("YYYY-MM-DD")}
                onChange={(e) => setdates({ ...dates, enddate: e.target.value })}
              />
            </label>
          </div>
        </div>
        <div className="mt-6 min-h-0 py-1">
          {dagboeken.length > 0 ? (
            <DagBoekList
              editTekst={(item, cmd) => loadEntryFromList(item, cmd)}
              showText={(item) => loadEntryFromList(item)}
              dagboeken={dagboeken}
            />
          ) : (
            <div className="rounded-xl border border-dashed border-wa-border bg-wa-panel2/40 px-4 py-8 text-center">
              <p className="text-sm text-wa-muted">
                Geen gegevens gevonden voor deze patiënt in dit datumbereik.
              </p>
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <div className="relative flex min-h-0 flex-1 flex-col bg-wa-app text-wa-text lg:h-[calc(100dvh-4rem)] lg:flex-row">
      <Transition.Root show={mobilePanelOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[65] lg:hidden" onClose={setMobilePanelOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/60" aria-hidden="true" />
          </Transition.Child>
          <div className="fixed inset-0 flex">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-out duration-200"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in duration-150"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative flex h-full w-[min(100%,22rem)] flex-col border-r border-wa-border bg-wa-panel shadow-xl">
                <div className="flex items-center justify-between border-b border-wa-border px-4 py-3">
                  <Dialog.Title className="text-sm font-semibold text-wa-text">
                    Patiënt &amp; dagboeken
                  </Dialog.Title>
                  <button
                    type="button"
                    className="rounded-lg p-2 text-wa-muted hover:bg-wa-hover hover:text-wa-text"
                    onClick={() => setMobilePanelOpen(false)}
                    aria-label="Sluiten"
                  >
                    <XMarkIcon className="h-5 w-5" />
                  </button>
                </div>
                <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4">
                  {renderSidebarBody(true)}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>

      <aside className="hidden h-full max-h-full w-[min(100%,22rem)] shrink-0 overflow-y-auto border-r border-wa-border bg-wa-panel px-4 py-6 sm:px-5 lg:block 2xl:w-[26rem]">
        {renderSidebarBody(false)}
      </aside>

      <main className="min-h-0 min-w-0 flex-1 overflow-y-auto bg-wa-app lg:border-l lg:border-wa-border">
        <div className="mx-auto max-w-5xl px-3 pb-10 pt-3 sm:px-6 sm:pt-4 lg:px-8">
          <div className="mb-3 flex lg:hidden">
            <button
              type="button"
              onClick={() => setMobilePanelOpen(true)}
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl border border-wa-border bg-wa-panel2 px-3 py-2.5 text-sm font-semibold text-wa-text shadow-sm transition-colors hover:border-wa-accent/40 hover:bg-wa-hover"
            >
              <Bars3Icon className="h-5 w-5 shrink-0 text-wa-accent" aria-hidden />
              Patiënt &amp; dagboeken
            </button>
          </div>

          <div className="overflow-hidden rounded-2xl border border-wa-border bg-wa-panel shadow-[0_20px_60px_-36px_rgba(0,0,0,0.5)]">
            <div className="flex flex-col gap-3 border-b border-wa-border bg-gradient-to-br from-wa-panel via-wa-panel2/50 to-wa-panel px-4 py-4 sm:flex-row sm:items-center sm:justify-end sm:px-6">
              {formData?.title ? (
                <button
                  type="button"
                  onClick={() => setOpen(true)}
                  className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-wa-border bg-wa-panel2 px-4 py-2.5 text-sm font-semibold text-wa-text shadow-sm transition-colors hover:border-wa-accent/40 hover:bg-wa-hover sm:w-auto sm:py-2"
                >
                  Opmerking plaatsen
                  <DocumentIcon className="h-5 w-5 text-wa-accent" aria-hidden="true" />
                </button>
              ) : (
                <p className="w-full text-center text-xs text-wa-muted sm:text-right">
                  Selecteer een dagboek-item om te beoordelen.
                </p>
              )}
            </div>

            <div className="space-y-5 p-4 sm:p-6">
              <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                <div
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(formData?.title || ""),
                  }}
                  className="min-w-0 flex-1 rounded-xl border border-wa-border bg-wa-panel2/50 px-4 py-3 text-lg font-semibold text-wa-text sm:text-xl"
                />
                {formData?.url ? (
                  <a
                    href={formData?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="shrink-0 sm:max-w-xs"
                  >
                    <div className="cursor-pointer rounded-xl border border-wa-border bg-wa-panel2 p-3 transition-colors hover:border-wa-accent/40 hover:bg-wa-hover">
                      <span className="flex items-center gap-2">
                        <PaperClipIcon className="h-6 w-6 shrink-0 text-wa-accent" />
                        <span className="text-sm font-medium leading-snug text-wa-text">
                          Afbeelding maaltijd
                        </span>
                      </span>
                    </div>
                  </a>
                ) : null}
              </div>
              <TypeNote admin={showEdit} Eetdagboek={formData} />
            </div>
          </div>
        </div>
      </main>
      {formData && (
        <RPDrawerComment
          onClick={Opslaan}
          item={formData}
          admin={formData}
          setUpdateAdmin={setFormData}
          setOpen={setOpen}
          open={open}
        />
      )}
    </div>
  );
};

export default EetdagboekAdmin;
